import { render, staticRenderFns } from "./CampaignsFlowView.vue?vue&type=template&id=4485b07c&scoped=true&"
import script from "./CampaignsFlowView.vue?vue&type=script&lang=js&"
export * from "./CampaignsFlowView.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsFlowView.vue?vue&type=style&index=0&id=4485b07c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4485b07c",
  null
  
)

export default component.exports